import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Contract } from "../models/Contract";
import { ContractParameters } from "../models/ContractParameters";
import { LocationListItem } from "../models/LocationListItem";
import { StagingContracts } from "../models/StagingContracts";

@Injectable({
    providedIn: 'root'
})
export class ContractDataService {
    constructor(private http: HttpClient) {

    }

    getContractLocations(parms: ContractParameters): Observable<LocationListItem[]> {
        return this.http.post<LocationListItem[]>('api/contract/getcontractlocations', parms);
    }

    getOpenContracts(parms: ContractParameters): Observable<Contract[]> {
        return this.http.post<Contract[]>('api/contract/getopencontracts', parms);
    }

    getStagingContracts(parms: ContractParameters): Observable<StagingContracts> {
        return this.http.post<StagingContracts>('api/contract/getstagingcontracts', parms);
    }
}